export default __webpack_public_path__ + "static/media/celery.3b82be41.png";